import { fail, success } from '@helpers/result-helper.js'
import { isSuccess } from '@/helpers/http-status-helpers'
import toast from '@services/toasts/index.js'

// eslint-disable-next-line no-unused-vars
import ClientPayClassClassificationViewModel from '@/models/client/clientPayClassClassificationViewModel'

const getDefaultState = () => {
  return {
    clientQueue: [],
    locationQueue: [],
    groupQueue: [],

    clientList: [],
    locationList: [],
    groupList: [],

    loadingCountLocation: 0,
    loadingCountClient: 0,
    loadingCountGroup: 0,
  }
}

const state = getDefaultState()

export default {
  namespaced: true,
  state,

  getters: {
    clientList: (state) => state.clientList,
    locationList: (state) => state.locationList,
    groupList: (state) => state.groupList,
    clientQueue: (state) => state.clientQueue,
    locationQueue: (state) => state.locationQueue,
    groupQueue: (state) => state.groupQueue,
    isLoadingLocation: (state) => state.loadingCountLocation > 0,
    isLoadingClient: (state) => state.loadingCountClient > 0,
    isLoadingGroup: (state) => state.loadingCountGroup > 0,
    getLocation: (state) => (id) => {
      const item = state.locationList.find((location) => location.id === id)
      if (item) {
        return item
      } else {
        return { id: -1, name: '', level: 'LOCATION' }
      }
    },
    getClient: (state) => (id) => {
      const item = state.clientList.find((client) => client.id === id)
      if (item) {
        return item
      } else {
        return { id: -1, name: '', level: 'CLIENT' }
      }
    },
    getGroup: (state) => (id) => {
      const item = state.groupList.find((group) => group.id === id)
      if (item) {
        return item
      } else {
        return { id: -1, name: '', level: 'GROUP' }
      }
    },
  },

  mutations: {
    ADD_LOCATION_ITEM(state, id) {
      if (!state.locationQueue.includes(id)) {
        state.locationQueue.push(id)
      }
    },
    ADD_CLIENT_ITEM(state, id) {
      if (!state.clientQueue.includes(id)) {
        state.clientQueue.push(id)
      }
    },
    ADD_GROUP_ITEM(state, id) {
      if (!state.groupQueue.includes(id)) {
        state.groupQueue.push(id)
      }
    },
    START_LOADING_LOCATION(state) {
      state.loadingCountLocation++
    },
    FINISH_LOADING_LOCATION(state) {
      state.loadingCountLocation--
    },

    START_LOADING_CLIENT(state) {
      state.loadingCountClient++
    },
    FINISH_LOADING_CLIENT(state) {
      state.loadingCountClient--
    },

    START_LOADING_GROUP(state) {
      state.loadingCountGroup++
    },
    FINISH_LOADING_GROUP(state) {
      state.loadingCountGroup--
    },
    REMOVE_LOCATION_ITEMS(state, ids) {
      state.locationQueue = state.locationQueue.filter(
        (location) => !ids.includes(location)
      )
    },

    REMOVE_CLIENT_ITEMS(state, ids) {
      state.clientQueue = state.clientQueue.filter(
        (client) => !ids.includes(client)
      )
    },

    REMOVE_GROUP_ITEMS(state, ids) {
      state.groupQueue = state.groupQueue.filter(
        (group) => !ids.includes(group)
      )
    },
    ADD_LOCATIONS(state, locations) {
      state.locationList = [...state.locationList, ...locations]
    },
    ADD_CLIENTS(state, clients) {
      state.clientList = [...state.clientList, ...clients]
    },
    ADD_GROUPS(state, groups) {
      state.groupList = [...state.groupList, ...groups]
    },
    CLEAR_STORE(state) {
      // Resets store to default state
      Object.assign(state, getDefaultState())
    },
  },
  actions: {
    /**
     *
     * @param {*} param0
     * @param {*} Object {"Ids":[1],"Type":"CLIENT"}
     * @returns promise {"id":1,"name":"Client Name","level":"ClIENT","clientTree":{"id":0,"name":null,"level":null,"children":null}}
     *
     */
    async pokeLocation({ commit, getters, dispatch }, payload) {
      if (payload > 0) {
        // otherwise put into queue
        const item = getters.getLocation(payload)
        // put in queue
        if (item.id === -1) {
          commit('ADD_LOCATION_ITEM', payload)
        }
      }
      // if already running then simply end here
      if (!getters.isLoadingLocation && getters.locationQueue.length > 0) {
        commit('START_LOADING_LOCATION')

        // construct payload
        const newPayload = JSON.parse(JSON.stringify(getters.locationQueue))

        const response = await this.$api.client.getLocation(newPayload)
        if (isSuccess(response.status)) {
          commit('FINISH_LOADING_LOCATION')

          commit('ADD_LOCATIONS', response.data)

          // start again
          dispatch('pokeLocation', -2)
        } else {
          // wasn't success...
        }
        commit('REMOVE_LOCATION_ITEMS', newPayload)
      }
    },
    async pokeClient({ commit, getters, dispatch }, payload) {
      if (payload > 0) {
        // otherwise put into queue
        const item = getters.getClient(payload)
        // put in queue
        if (item.id === -1) {
          commit('ADD_CLIENT_ITEM', payload)
        }
      }
      // if already running then simply end here
      if (!getters.isLoadingClient && getters.clientQueue.length > 0) {
        commit('START_LOADING_CLIENT')

        // construct payload
        const newPayload = JSON.parse(JSON.stringify(getters.clientQueue))

        const response = await this.$api.client.getClient(newPayload)
        if (isSuccess(response.status)) {
          commit('FINISH_LOADING_CLIENT')

          commit('ADD_CLIENTS', response.data)

          // todo: remove items
          commit('REMOVE_CLIENT_ITEMS', newPayload)
          // start again
          dispatch('pokeClient', -2)
        }
      }
    },
    async pokeGroup({ commit, getters, dispatch }, payload) {
      if (payload > 0) {
        // otherwise put into queue
        const item = getters.getGroup(payload)
        // put in queue
        if (item.id === -1) {
          commit('ADD_GROUP_ITEM', payload)
        }
      }
      // if already running then simply end here
      if (!getters.isLoadingGroup && getters.groupQueue.length > 0) {
        commit('START_LOADING_GROUP')

        // construct payload
        const newPayload = JSON.parse(JSON.stringify(getters.groupQueue))

        const response = await this.$api.client.getGroup(newPayload)
        if (isSuccess(response.status)) {
          commit('FINISH_LOADING_GROUP')

          commit('ADD_GROUPS', response.data)

          // todo: remove items
          commit('REMOVE_GROUP_ITEMS', newPayload)
          // start again
          dispatch('pokeGroup', -2)
        }
      }
    },
    /**
     * @param {Number} clientId
     * @returns {Promise<ClientPayClassClassificationViewModel[]>}
     */
    async getPayClassClassificationsByClientId(_, clientId) {
      try {
        const response = await this.$api.client.getPayClassClassifications(
          clientId
        )
        if (isSuccess(response.status)) {
          return success(response.data)
        }
      } catch (ex) {
        toast.error(
          this.$i18n.t(
            'subBubbleAgreements.errorMessages.failedToLoadClassifications'
          )
        )
        return fail()
      }
    },
    /**
     * @param {Number} clientGroupId
     * @returns {Promise<ClientPayClassClassificationViewModel[]>}
     */
    async getPayClassClassificationsByClientGroupId(_, clientGroupId) {
      try {
        const response = await this.$api.clientGroup.getPayClassClassifications(
          clientGroupId
        )
        if (isSuccess(response.status)) {
          return success(response.data)
        }
      } catch (ex) {
        toast.error(
          this.$i18n.t(
            'subBubbleAgreements.errorMessages.failedToLoadClassifications'
          )
        )
        return fail()
      }
    },
  },
}
